export const CANDIDATE_USER_DETAILS_REQUEST = "CANDIDATE_USER_DETAILS_REQUEST";
export const CANDIDATE_USER_DETAILS_SUCCESS = "CANDIDATE_USER_DETAILS_SUCCESS";
export const CANDIDATE_USER_DETAILS_FAIL = "CANDIDATE_USER_DETAILS_FAIL";

export const CANDIDATE_USER_DETAILS_UPDATE_REQUEST =
  "CANDIDATE_USER_DETAILS_UPDATE_REQUEST";
export const CANDIDATE_USER_DETAILS_UPDATE_SUCCESS =
  "CANDIDATE_USER_DETAILS_UPDATE_SUCCESS";
export const CANDIDATE_USER_DETAILS_UPDATE_FAIL =
  "CANDIDATE_USER_DETAILS_UPDATE_FAIL";

export const CANDIDATE_FETCH_JOBS_REQUEST = "CANDIDATE_FETCH_JOBS_REQUEST";
export const CANDIDATE_FETCH_JOBS_SUCCESS = "CANDIDATE_FETCH_JOBS_SUCCESS";
export const CANDIDATE_FETCH_JOBS_FAIL = "CANDIDATE_FETCH_JOBS_FAIL";

export const CANDIDATE_JOBS_DETAILS_REQUEST = "CANDIDATE_JOBS_DETAILS_REQUEST";
export const CANDIDATE_JOBS_DETAILS_SUCCESS = "CANDIDATE_JOBS_DETAILS_SUCCESS";
export const CANDIDATE_JOBS_DETAILS_FAIL = "CANDIDATE_JOBS_DETAILS_FAIL";

export const CANDIDATE_USER_PREREQUSIT_REQUEST =
  "CANDIDATE_USER_PREREQUSIT_REQUEST";
export const CANDIDATE_USER_PREREQUSIT_SUCCESS =
  "CANDIDATE_USER_PREREQUSIT_SUCCESS";
export const CANDIDATE_USER_PREREQUSIT_FAIL = "CANDIDATE_USER_PREREQUSIT_FAIL";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_RESET = "LOGIN_RESET";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const LOGOUT = "LOGOUT";
export const ADD_LANGUAGE = "ADD_LANGUAGE";
export const CAN_RESET = "CAN_RESET";
export const TOGGLE_CANDIDATE_IS_ON = "TOGGLE_CANDIDATE_IS_ON";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
